import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetDefinitionChangeParamsRequest = {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string
  [key: string]: string | number | boolean | undefined;
}

export type IDefinitionChangeParam = {

}

export type GetDefinitionChangeParamsResponse = BasePagingResponse<Array<IDefinitionChangeParam>>;

async function getDefinitionChangeParamsList(
  data: GetDefinitionChangeParamsRequest
): Promise<GetDefinitionChangeParamsResponse> {
  try {
    return (await axiosInstance.post("/DefinitionChangeParam/List", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetDefinitionChangeParamsList() {
  return useMutation<GetDefinitionChangeParamsResponse, Error, GetDefinitionChangeParamsRequest>((variables) =>
    getDefinitionChangeParamsList(variables)
  );
}
